import { useMemo } from 'react';

import {
	calculateEditorOffsetFromParent,
	calculateRendererOffsetFromParent,
} from '@confluence/comments-util/entry-points/domUtils';

type SidebarProps = {
	annotationElement: HTMLElement | null | undefined;
	isEditor: boolean;
	isViewCommentMode?: boolean;
};

export const useCommentSidebarOffset = ({
	annotationElement,
	isEditor,
	isViewCommentMode,
}: SidebarProps) => {
	return useMemo(() => {
		if (!annotationElement) return 0;

		if (isEditor) {
			return calculateEditorOffsetFromParent(
				annotationElement,
				'.fabric-editor-popup-scroll-parent',
			);
		}

		return calculateRendererOffsetFromParent(
			annotationElement,
			`[data-annotation-draft-mark="true"]`,
			Boolean(isViewCommentMode),
		);
	}, [isEditor, annotationElement, isViewCommentMode]);
};
